import { render, staticRenderFns } from "./DocumentTemplateReceiptPreview.vue?vue&type=template&id=4d138c5c&scoped=true&lang=pug&"
import script from "./DocumentTemplateReceiptPreview.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateReceiptPreview.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplateReceiptPreview.vue?vue&type=style&index=0&id=4d138c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d138c5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow,VSpacer})
